import { HttpInterceptorFn } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { inject } from "@angular/core";
import { AuthenticationService } from "@core/services/authentication.service";
import { ToastService } from "@core/services/toast.service";
import { environment } from "@env/environment";
import { DeveloperService } from "@core/services/developer.service";

export const DebugHttpInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthenticationService);
  const devService = inject(DeveloperService);
  const toast = inject(ToastService);
  const logId = Math.random().toString(36).slice(2,8);

  if (authService.isDeveloper()) {
    devService.addLog(logId, `➡️ Request START: ${req.method} ${req.url}\n${JSON.stringify(req.body)}`);
  }

  return next(req).pipe(
    tap({
      next: (event) => {
        if (authService.isDeveloper()) {
          devService.addLog(logId, `✅ Response event for ${req.method} ${req.url}\n${JSON.stringify(event)}`);
        }
        if (!environment.production) {
          console.log('HTTP Response:', event);
        }
      },
      error: (error) => {
        if (authService.isDeveloper()) {
          devService.addLog( logId, `❌ ERROR for ${req.method} ${req.url} → Status: ${error.status}, Message: ${error.message}, Details: ${error.error?.message}`);
          toast.message(`Státusz: ${error.status}, Message: ${error.message} Error: ${error.error?.message}`, {type: 'danger'})
        }
        if (!environment.production) {
          console.error('HTTP Error:', error);
        }
      },
      complete: () => {
        if (authService.isDeveloper()) {
          devService.addLog(logId, `⬅️ Request END: ${req.method} ${req.url}`);
        }
      }
    })
  );
};
